import React, { FC } from "react"
import { useBookingsCount } from "../../bookings/hooks"
import { useAppSelector } from "../../hooks"
import { selectSearchDescription } from "../searchSlice"



const SearchResultsInfo: FC = () => {
  const count = useBookingsCount()
  const searchDescription = useAppSelector(selectSearchDescription)

  return (
    <div className="alert alert-info">
      Showing {count} results on your search {searchDescription}
    </div>
  )
}


export default SearchResultsInfo